import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Webform, {
  useWebformElement,
  WebformElementWrapper,
} from "gatsby-drupal-webform"
import { navigate } from "gatsby"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import {
  contactContainer,
  contactFormTitle,
  inputContactForm,
  textLabel,
} from "../styles/contactez-nous.module.scss"
import "../styles/contact-form.scss"
import { ContactezNousImage, Title } from "../styled-components/contact-styled"
import Ariane from "../components/Ariane/ariane"
import { useWebform } from "../hooks/use-webform"
import { useBuildData } from "../hooks/use-build-data"
import { MaintenancePage } from "../components/MaintenancePage/maintenance-page"

const CustomSubmit = () => {
  return (
    <button className="btn" type="submit">
      Envoyer le formulaire
    </button>
  )
}

const ContactForm = ({ arianeDisplayed }) => {
  const [isMaintenance, setIsMaintenance] = useState(false)
  const [honeyValue, setHoneyValue] = useState(false) // HoneyPot state -> Allow to remove webform if bot complete first form input (which is first in HTML)
  const [locked, setLocked] = useState(false)
  const data = useWebform()
  const buildInfos = useBuildData().site_settings.display_contact_form
  if (!buildInfos) {
    return null
  }
  useEffect(() => {
    const fetchMaintenance = async () => {
      const resp = await fetch(
        process.env.GATSBYSIDE_DRUPAL_URL + `/api/get/maintenance/state`
      )
      const maintenanceMessage = await resp.text()
      setIsMaintenance(maintenanceMessage !== "0")
    }

    fetchMaintenance()
  }, [])
  return (
    <Layout message="Formulaire de contact">
      <SEO title="Formulaire de contact" />
      {arianeDisplayed && (
        <Ariane pageName="Formulaire de contact" isListing={true} />
      )}
      {!isMaintenance && (
        <>
          <form id="my_contactform" action="/mycontactform">
            <label className={inputContactForm} htmlFor="subject">
              <input
                onChange={(element) => setHoneyValue(element.target.value)}
                className={inputContactForm}
                autoComplete="off"
                type="text"
                id="subject"
                name="subject"
                placeholder="Your subject here"
                tabIndex="-1"
                style={
                  typeof document !== `undefined`
                    ? document.styleSheets[0].disabled
                      ? { display: "none" }
                      : {}
                    : {}
                }
              />
            </label>
          </form>
          <div className={contactContainer}>
            <div>
              <Title className={contactFormTitle}>Contactez nous !</Title>
              <p>Merci de renseigner tous les champs ci-dessous</p>
              {!honeyValue && (
                <Webform
                  webform={data.webformWebform}
                  buttonComponent={CustomSubmit}
                  endpoint={`${process.env.GATSBYSIDE_DRUPAL_URL}/react_webform_backend/submit`}
                  onSubmit={() => {
                    if (!locked) {
                      setLocked(true)
                      return true
                    }
                    return false
                  }}
                  onSuccess={() => {
                    if (typeof window !== `undefined`) {
                      navigate("/contact-confirmation", {
                        state: { formValidation: true },
                      })
                    }
                  }}
                  onError={() => {
                    if (typeof window !== `undefined`) {
                      navigate("/contact-confirmation", {
                        state: { formValidation: false },
                      })
                    }
                  }}
                  customComponents={{
                    email: CustomInput,
                    textfield: CustomInput,
                  }}
                />
              )}
            </div>
            <ContactezNousImage aria-hidden={true} />
          </div>
        </>
      )}
      {isMaintenance && <MaintenancePage />}
    </Layout>
  )
}
const CustomInput = ({ element, error }) => {
  const [inputProps, settings] = useWebformElement(element, {
    name: element.name,
    type: element.type,
    id: element.attributes[0].value,
  })
  useEffect(() => {
    const defaultLabel = document.querySelectorAll(
      ".text-field-label, .email-field-label, .select-field-label"
    )
    defaultLabel.forEach((domElement) => {
      domElement.remove()
    })
  }, [])

  return (
    <WebformElementWrapper settings={settings} error={error}>
      <label htmlFor={element.attributes[5].value} className={textLabel}>
        {element.attributes[0].value}
      </label>
      <input
        {...inputProps}
        id={element.attributes[5].value}
        className="form-control"
        autoComplete={element.attributes[2].value}
      />
    </WebformElementWrapper>
  )
}

ContactForm.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

CustomInput.propTypes = {
  element: PropTypes.array,
  error: PropTypes.array,
}

export default ContactForm
